import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { handleActions } from 'redux-actions';
import { fetchConnectionInfo, fetchRoles, updateConnectionInfo, updateRoles, connectionSuccess, disconnectSuccess } from './actions';
import { reduxKey } from './constants';
const handler = handleActions({
    [fetchConnectionInfo.toString()]: (state)=>_object_spread_props(_object_spread({}, state), {
            connection: _object_spread_props(_object_spread({}, state.connection), {
                isLoading: true,
                isReady: false
            })
        }),
    [updateConnectionInfo.toString()]: (state, { payload })=>_object_spread_props(_object_spread({}, state), {
            connection: _object_spread_props(_object_spread({}, payload), {
                isLoading: false,
                isReady: true
            })
        }),
    [connectionSuccess.toString()]: (state, { payload })=>_object_spread_props(_object_spread({}, state), {
            connection: _object_spread_props(_object_spread({}, state.connection), {
                connected: true,
                connectedJustNow: payload.justNow
            })
        }),
    [disconnectSuccess.toString()]: (state, { payload })=>_object_spread_props(_object_spread({}, state), {
            connection: {
                isReady: false
            },
            roles: {
                isReady: false
            }
        }),
    [fetchRoles.toString()]: (state)=>_object_spread_props(_object_spread({}, state), {
            roles: _object_spread_props(_object_spread({}, state.roles), {
                isLoading: true,
                isReady: false
            })
        }),
    [updateRoles.toString()]: (state, { payload: { roles } })=>_object_spread_props(_object_spread({}, state), {
            roles: {
                roles,
                isLoading: false,
                isReady: true
            }
        })
}, {
    isReduxInitialized: false,
    connection: {
        isReady: false
    },
    roles: {
        isReady: false
    }
});
export default {
    [reduxKey]: handler
};

//# sourceMappingURL=reducer.js.map